import type { RouterApi } from '@lumapps/router/api';

import { getPlayVideoRouteById } from '../routes';

interface GetFullVideoLinkProps {
    /** Video id */
    videoId: string;
    /** Instance slug */
    instanceSlug?: string;
}

/**
 * This util returns the absolute url of a video page
 *
 * @returns Absolute url of a video
 * @example https://my-domain.com/qa-layout/home/ls/play-playlist/1234-56è8-9101112
 */
export const getFullVideoLink = (
    { videoId, instanceSlug }: GetFullVideoLinkProps,
    getUrl: RouterApi['getUrl'],
): string => {
    return getUrl(getPlayVideoRouteById(videoId, instanceSlug), { absolute: 'location-based' });
};
